<template>
  <div class="column is-2 menu-column">
    <aside class="menu">
      <h1 class="title is-4">Vald kund</h1>
      <ul class="menu-list">
        <li :class="{ 'is-active': selected == 'settings' }">
          <a @click="selected = 'settings'"
            ><i class="fas fa-cog"></i>Kundinställningar</a
          >
        </li>
        <li :class="{ 'is-active': selected == 'bookings' }">
          <a @click="selected = 'bookings'"
            ><i class="fas fa-users"></i>Bokningar</a
          >
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
export default {
  name: "CustomerOptions",
  data: function () {
    return {
      selected: "bookings",
    };
  },
  watch: {
      selected: function() {
          this.$emit("input", this.selected)
      }
  },
};
</script>

<style scoped>
.is-active a {
  background-color: hsl(217, 71%, 53%);
  color: white !important;
  border-radius: 10px;
}

.menu-column {
  text-align: left;
  border: 1px solid #dbdbdb;
}

.fas {
  margin-right: 15px;
  width: 20px;
  text-align: center;
}
</style>